import { CorrectInvalidCargoParam } from '../../Cargo/api/CargoApi';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { InvalidCargoModel } from '../models/InvalidCargoModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface invalidCargoState {
    invalidCargoData: InvalidCargoModel[],
    invalidCargoDisplay: InvalidCargoModel[],
    selectedItem: InvalidCargoModel | null,
    searchText: string,
    orderBy: string,
    orderDirection: OrderDirection,
    refreshInvalidCargoTable: number,
    openEditInvalidCargoModal: boolean,
    editItemParam: CorrectInvalidCargoParam,
}

const initialState: invalidCargoState = {
    invalidCargoData: [],
    invalidCargoDisplay: [],
    selectedItem: null,
    searchText: "",
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
    refreshInvalidCargoTable: 0,
    openEditInvalidCargoModal: false,
    editItemParam: {
        id: "",
        charterer: "",
        cargoType: 0,
        loadPort: 0,
        disport: 0
    }
}

export const InvalidCargoSlice = createSlice({
    name: "InvalidCargoInput",
    initialState,
    reducers: {
        setInvalidCargoData: (state, action: PayloadAction<InvalidCargoModel[]>) => {
            state.invalidCargoData = action.payload;
        },
        setInvalidCargoDisplay: (state, action: PayloadAction<InvalidCargoModel[]>) => {
            state.invalidCargoDisplay = action.payload;
        },
        setSelectedItem: (state, action: PayloadAction<InvalidCargoModel>) => {
            state.selectedItem = action.payload;
        },
        setInvalidCargoSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setInvalidCargoOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setInvalidCargoOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
        setRefreshInvalidCargoTable: (state, action: PayloadAction<number>) => {
            state.refreshInvalidCargoTable = action.payload;
        },
        setOpenEditInvalidCargoModal: (state, action: PayloadAction<boolean>) => {
            state.openEditInvalidCargoModal = action.payload;
        },
        setCorrectInvalidCargoParam: (state, action: PayloadAction<CorrectInvalidCargoParam>) => {
            state.editItemParam = action.payload;
        },
    }
});

export const invalidCargoSelector = createSelector(
    (state: RootState) => state.invalidCargo,
    (data) => data
);

export const {
    setInvalidCargoData,
    setInvalidCargoDisplay,
    setSelectedItem,
    setInvalidCargoSearchText,
    setInvalidCargoOrderBy,
    setInvalidCargoOrderDirection,
    setRefreshInvalidCargoTable,
    setOpenEditInvalidCargoModal,
    setCorrectInvalidCargoParam
} = InvalidCargoSlice.actions;

export default InvalidCargoSlice.reducer;